/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-link',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoLinkComponent extends NestedOption {
    @Input()
    get border(): { color?: string, visible?: boolean, width?: number } {
        return this._getOption('border');
    }
    set border(value: { color?: string, visible?: boolean, width?: number }) {
        this._setOption('border', value);
    }

    @Input()
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    @Input()
    get colorMode(): string {
        return this._getOption('colorMode');
    }
    set colorMode(value: string) {
        this._setOption('colorMode', value);
    }

    @Input()
    get hoverStyle(): { border?: { color?: string, visible?: boolean, width?: number }, color?: string, hatching?: { direction?: string, opacity?: number, step?: number, width?: number }, opacity?: number } {
        return this._getOption('hoverStyle');
    }
    set hoverStyle(value: { border?: { color?: string, visible?: boolean, width?: number }, color?: string, hatching?: { direction?: string, opacity?: number, step?: number, width?: number }, opacity?: number }) {
        this._setOption('hoverStyle', value);
    }

    @Input()
    get opacity(): number {
        return this._getOption('opacity');
    }
    set opacity(value: number) {
        this._setOption('opacity', value);
    }


    protected get _optionPath() {
        return 'link';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoLinkComponent
  ],
  exports: [
    DxoLinkComponent
  ],
})
export class DxoLinkModule { }
